import { CorrespondenceMethodEnum, CountryCodeEnum } from '../../../types/forms';
import { CustomerDetailsFormModel_MX } from './formModel';

export const getInitialValues = (): CustomerDetailsFormModel_MX => {
  return {
    gender: undefined,
    title: undefined,
    maritalStatus: undefined,
    makeIndemnifier: undefined,
    firstName: undefined,
    lastName: undefined,
    middleName: undefined,
    maidenName: undefined,
    dateOfBirth: undefined,
    email: undefined,
    telephoneType: undefined,
    phoneNumber: undefined,
    countryCode: CountryCodeEnum.Ireland,
    correspondenceMethod: CorrespondenceMethodEnum.email,
    ccrType: undefined,
    ccrId: undefined,
  };
};
